module.exports = __webpack_public_path__ + "img/bg.210f345b.png";